import { UnwrapHelper } from '../UnwrapHelper';
export class GetObjectHelper extends UnwrapHelper {
}

//# sourceMappingURL=GetObjectHelper.js.map
